export * from './nav-dropdown.directive';



// WEBPACK FOOTER //
// D:/desv/producao/ITN/srvHCWaba/src/app/directives/nav-dropdown/index.ts